import { useEffect, useState } from 'react';
import { fechaLocalIso, formatearMonedaArs, type TarifaEmpresaDTO } from '@ausentia/shared';
import { api, ErrorApi } from '../api/cliente.js';
import { useToast } from '../componentes/Toast.js';

// Fecha local, no UTC: entre las 21:00 y las 00:00 hora Argentina, toISOString()
// devuelve mañana y la tarifa recién guardada no aplicaría a los controles de hoy.
const hoyIso = () => fechaLocalIso();

export function Tarifas() {
  const [tarifas, setTarifas] = useState<TarifaEmpresaDTO[] | null>(null);
  const [error, setError] = useState('');

  async function refrescar() {
    try {
      setTarifas(await api.get<TarifaEmpresaDTO[]>('/api/operador/tarifas'));
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudieron cargar las tarifas');
    }
  }
  useEffect(() => { void refrescar(); }, []);

  return (
    <section>
      <h2>Tarifas a empresas</h2>
      <p className="muted">Monto que cobrás a cada empresa por visita, según el tipo de control. Guardar crea una nueva vigencia desde hoy.</p>
      {error && <div className="error-box" role="status">{error}</div>}
      {tarifas === null ? (
        <div className="cargando">Cargando…</div>
      ) : (
        <table className="tabla">
          <thead>
            <tr>
              <th scope="col">Empresa</th>
              <th scope="col">Tipo de control</th>
              <th scope="col">Tarifa actual</th>
              <th scope="col">Nueva tarifa (ARS)</th>
              <th scope="col" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {tarifas.map((t) => (
              <FilaTarifa key={`${t.empresaId}:${t.tipoControl}`} tarifa={t} onGuardado={refrescar} />
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}

function FilaTarifa({ tarifa, onGuardado }: { tarifa: TarifaEmpresaDTO; onGuardado: () => Promise<void> }) {
  const toast = useToast();
  const [pesos, setPesos] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  async function guardar() {
    const valor = Number(pesos);
    if (!pesos || Number.isNaN(valor) || valor < 0) {
      setError('Ingresá un monto válido');
      return;
    }
    setGuardando(true);
    setError('');
    try {
      await api.put('/api/operador/tarifas', {
        empresaId: tarifa.empresaId,
        tipoControl: tarifa.tipoControl,
        montoCentavos: Math.round(valor * 100),
        vigenteDesde: hoyIso(),
      });
      setPesos('');
      await onGuardado();
      toast.mostrar(`Tarifa de ${tarifa.empresaNombre} (${tarifa.tipoControlNombre}) actualizada`);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo guardar');
    } finally {
      setGuardando(false);
    }
  }

  return (
    <tr>
      <td>{tarifa.empresaNombre}</td>
      <td>{tarifa.tipoControlNombre}</td>
      <td>{tarifa.montoCentavos !== null ? formatearMonedaArs(tarifa.montoCentavos) : <span className="insignia ambar">sin tarifa</span>}</td>
      <td>
        <input
          type="number"
          min={0}
          step="0.01"
          inputMode="decimal"
          aria-label={`Nueva tarifa ${tarifa.empresaNombre} ${tarifa.tipoControl}`}
          value={pesos}
          onChange={(e) => setPesos(e.target.value)}
          placeholder="0,00"
        />
        {error && <p className="mini" style={{ color: 'var(--rojo)' }}>{error}</p>}
      </td>
      <td>
        <button className="secundario" style={{ width: 'auto' }} onClick={guardar} disabled={guardando}>
          {guardando ? '…' : 'Guardar'}
        </button>
      </td>
    </tr>
  );
}
